import { getDecimalDigits } from '../../../../utils/math';

export const getIsExceedDecimalDigitLimit = (value: string, dpLimit?: number) => {
  const limit = dpLimit || 6;

  return getDecimalDigits(value) > limit;
};
